


































































































































































































































































import { Component, Prop, Vue, Inject, Watch } from 'vue-property-decorator';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { CrudService } from '@/data/services/crud.service';
import { User, UserGender, UserType } from '@/data/models/user.model';
import { Country } from '@/data/models/country.model';
import { Comune } from '@/data/models/comune.model';
import { Provincia } from '@/data/models/provincia.model';
import { Md5 } from 'ts-md5/dist/md5';
import { Search } from '@/data/models/search.model';
import { ClassType } from 'class-transformer/ClassTransformer';
import { Page } from '@/data/models/page.model';
import { Headquarter } from '@/data/models/headquarter.model';
import { cloneDeep } from 'lodash';
import { newDate } from '@/data/utils/helper';
import { PasswordRegex } from '@/data/models/reset-password.model';

@Component({
	components: {
		ValidationObserver,
		ValidationProvider,
	},
})
export default class UtenteGeneralData extends Vue {
	@Prop() utente!: User;
	@Prop() editable!: boolean;

	@Inject('CrudService') utenteCrudService!: CrudService<User>;

	@Inject('CrudService') nazioneCrudService!: CrudService<Country>;
	@Inject('CrudService') provinciaCrudService!: CrudService<Provincia>;
	@Inject('CrudService') comuneCrudService!: CrudService<Comune>;
	@Inject('CrudService') hqCrudService!: CrudService<Headquarter>;

	newUtente!: User;

	password = {
		p1: '',
		p2: '',
	};
	passwordRegex = PasswordRegex;

	provinciaClass: ClassType<Provincia> = Provincia;
	comuneClass: ClassType<Comune> = Comune;
	countryClass: ClassType<Country> = Country;
	hqClass: ClassType<Headquarter> = Headquarter;

	provincia: Provincia | null = null;
	comune: Comune | null = null;
	country: Country | null = null;
	hq: Headquarter | null = null;

	comuneSearch: Search = new Search('comuni');
	hqSearch: Search = new Search('headquarter');

	typeItems: string[] = Object.keys(UserType).map(
		// @ts-ignore
		(k: string) => UserType[k]
	);
	genderItems: string[] = Object.keys(UserGender).map(
		// @ts-ignore
		(k: string) => UserGender[k]
	);

	maxdate!: Date

	constructor() {
		super();
		this.newUtente = new User();
		this.maxdate = newDate();
		this.maxdate.setFullYear(this.maxdate.getFullYear() - 18);
		this.hqSearch.addSimpleFilter('active', 1);
	}

	@Watch('utente', { immediate: true })
	onUserChange() {
		this.newUtente = cloneDeep(this.utente);
		this.loadNazioni();
		this.loadProvince();
		this.loadComuni();
		this.loadSede();
	}

	loadNazioni() {
		if (!this.newUtente.country) return;
		const search = new Search('country');
		search.addSimpleFilter('name', this.newUtente.country as string);
		this.nazioneCrudService
			.searchEntities(Country, 'country', search, new Page(1))
			.then(result => this.country = result[0]);
	}

	loadProvince() {
		if (!this.newUtente.province) return;
		const search = new Search('province');
		search.addSimpleFilter('descrizione', this.newUtente.province as string);
		this.provinciaCrudService
			.searchEntities(Provincia, 'province', search, new Page(1))
			.then(result => this.provincia = result[0]);
	}

	loadComuni() {
		if (!this.newUtente.province || !this.newUtente.comune) return;
		const search = new Search('comuni');
		search.addSimpleFilter('provincia', this.newUtente.province);
		search.addSimpleFilter('descrizione', this.newUtente.comune as string);
		this.comuneCrudService
			.searchEntities(Comune, 'comuni', search, new Page(1))
			.then(result => this.comune = result[0]);
	}

	loadSede() {
		if (!this.newUtente.hqid) return;
		this.hqCrudService.getEntity(Headquarter, 'headquarter', this.newUtente.hqid).then(result => this.hq = result);
	}

	onCountryChange() {
		this.newUtente.country = this.country!.name;
		this.newUtente.iso = this.country!.sigla;
		this.newUtente.province = undefined;
		this.newUtente.comune = undefined;
		this.provincia = null;
		this.comune = null;
	}

	onProvinciaChange() {
		if (this.provincia) {
			this.newUtente.province = this.provincia!.descrizione;
			this.comuneSearch.addSimpleFilter('provincia', this.provincia!.descrizione as string);
		} else {
			this.newUtente.province = undefined;
			this.comuneSearch.removeSimpleFilter('provincia');
		}
		this.newUtente.comune = undefined;
	}

	onComuneChange() {
		this.newUtente.comune = this.comune ? this.comune!.descrizione: undefined;
	}

	onHQChange() {
		this.newUtente.hqid = this.hq ? this.hq!.id : undefined;
	}

	submit() {
		if (this.password.p1.length > 0) {
			this.newUtente.password = Md5.hashStr(this.password.p1).toString();
		}
		this.utenteCrudService.createEntity(User, 'user', this.newUtente).then(result => {
			this.newUtente = result;
			this.$buefy.notification.open({
				message: this.$t('success-save') as string,
				type: 'is-success',
			});
			this.$emit('update:utente', result);
		}).catch(({ data }) => {
			this.$buefy.notification.open({
				message: data.msg || data.internal,
				type: 'is-danger',
			});
		});
	}

}
